'use client'

import Link from 'next/link'
import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'
import HeroVideo from '@/components/HeroVideo'
import ContactForm from '@/components/ContactForm'

export default function ContactPage() {
  return (
    <>
      <Navbar />
      <main className="min-h-screen bg-[#fdfcfb]">
        {/* ═══════════════════════════════════════════════════════════
            HERO — matches /about hero pattern: video background +
            dark veil + centered breadcrumb pill, title, description.
            ═══════════════════════════════════════════════════════════ */}
        <header
          data-nav-theme="dark"
          data-bg="#0f0f0f"
          className="relative isolate overflow-hidden bg-charcoal-900 text-white rounded-b-[32px]"
        >
          <HeroVideo
            src="/videos/project-details-hero.mp4"
            rate={1}
            className="absolute inset-0 w-full h-full object-cover -z-10"
          />
          <div
            aria-hidden
            className="absolute inset-0 -z-10 bg-gradient-to-b from-black/55 via-black/35 to-black/60"
          />

          <div className="relative px-6 md:px-16 pt-32 md:pt-40 pb-0">
            <div className="max-w-[1100px] mx-auto w-full text-center">
              <nav
                aria-label="Breadcrumb"
                className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.16em] text-white/70 mb-10 px-4 py-2 rounded-full border border-white/15 bg-white/5 backdrop-blur-sm"
              >
                <Link href="/" className="after:hidden hover:text-white transition-colors">
                  Home
                </Link>
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-white/40">
                  <path d="M9 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <span className="text-white">Contact</span>
              </nav>

              <h1
                className="font-display font-medium text-[clamp(2.25rem,6vw,4.5rem)] leading-[1.05] tracking-[-0.02em] text-white mb-8 mx-auto max-w-4xl"
              >
                Let&apos;s build something great together.
              </h1>

              <p
                className="text-base md:text-lg text-white/65 max-w-2xl mx-auto leading-relaxed"
              >
                Tell us about your project and we&apos;ll get back to you within 24 hours.
              </p>
            </div>

            <div className="h-20 md:h-28" aria-hidden />
          </div>
        </header>

        {/* Form */}
        <section data-bg="#fdfcfb" className="px-6 md:px-16 py-8 md:py-24">
          <div className="max-w-2xl mx-auto">
            <div
            >
              <ContactForm className="rounded-3xl shadow-2xl shadow-charcoal-900/10" />
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  )
}
